import React from 'react';
import { Field } from 'redux-form';
import styles from './ProgressReport.module.scss'
// /ProgressReport.module.css';


const WrappedTextInput = ({ input: { value: omitValue, ...inputProps }, label, name, createFile, createFileAt,  ...props }) => 
 

(
      <button onClick={createFileAt} className={styles.updateButton} style={{marginTop: '10px'}}>
        <input
          type="file" 
          id='fileInput'
          onChange={createFile}
          hidden
          // {...inputProps}
        />
        Добавить файл
      </button>

    );
    

const FileField = props => 
  (
  <Field
    component={WrappedTextInput}
    {...props}
  />
  
);

export default FileField;
